import { Component } from '@angular/core';
import { ThemeService } from './_service/theme.service';
import { environment } from './../environments/environment';
import { ComponentInteractionService } from './_service/component-interaction.service';
import { TranslateService } from '@ngx-translate/core';
import { FullscreenService } from './_service/fullscreen.service';
import { ConsoleToggleService } from './_service/console-toggle.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = environment.title;
  selectedTheme;
  activateTheme: any;
  ActivateinsideTheme: any;

  constructor(
    private themeService: ThemeService,
    private componentInteractionService: ComponentInteractionService,
    private translate: TranslateService,
    private fullscreenService: FullscreenService,
    private consoleToggleService: ConsoleToggleService
  ) {
    //Disable or enable console log
    this.consoleToggleService.disableConsoleInProduction();
    
    if (this.title == 'hul') {
      this.activateTheme = this.selectedTheme;
    } else if (this.title == 'cvs') {
      this.activateTheme = this.selectedTheme;
    } else if (this.title == 'paccar') {
      this.activateTheme = this.selectedTheme;
    }

    this.componentInteractionService.getThemeOption.subscribe((data) => {
      this.ActivateinsideTheme = data;
      this.themeService.setTheme(this.ActivateinsideTheme);
    });
    this.themeService.setTheme(this.activateTheme);
    const currentLang = this.translate.getBrowserLang();
    console.log('currentLang====', currentLang);
    this.translate.addLangs(['en', 'es']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    // this.fullscreenService;

  }

  ngOnInit() {}
  apiURL = environment.apiURL;
}
